import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import useUserService from '@hooks/queries/credential/onboarding/useUserService';
import { UserService } from '@daml.js/utility-credential-app-v0/lib/Utility/Credential/App/V0/Service/User';
import { ERR_OFF_CRED_PAID, SUC_OFF_CRED_PAID } from '../../utils/strings';
import { IClaim, ICredPayload } from './types';

export const useHandlePaid = () => {
  const userService = useUserService();
  const { submit } = useExerciseSubmission(
    UserService.UserService_OfferPaidCredential,
    SUC_OFF_CRED_PAID,
    ERR_OFF_CRED_PAID,
  );
  return async (payload: ICredPayload, claims: IClaim[]) => {
    if (!userService.data) {
      throw new Error('No user service');
    }
    if (
      !payload.billingPeriodMinutes ||
      !payload.feePerDayUsd ||
      !payload.depositInitialAmountUsd ||
      !payload.depositTargetAmountUsd
    ) {
      throw new Error('Missing required fields');
    }
    const p = {
      userServiceCid: userService.data.contractId,
      holder: payload.holder,
      id: payload.id,
      description: payload.description,
      claims,
      billingParams: {
        feePerDayUsd: { rate: payload.feePerDayUsd },
        billingPeriodMinutes: payload.billingPeriodMinutes,
        depositTargetAmountUsd: payload.depositInitialAmountUsd,
      },
      depositInitialAmountUsd: payload.depositInitialAmountUsd,
    };

    await submit({
      cid: userService.data.contractId,
      argument: p,
    });
  };
};
